import type { FormItemConfig } from "@ms/shared-components/comps/CompsForm";

/**
 * 角色Modal配置（合并自 roleModalConfig.ts）
 * 用于新建和修改角色的表单配置
 */
export const roleModalConfig = {
  /**
   * 创建角色表单配置
   */
  createFormConfig: (): FormItemConfig[] => [
    {
      name: "name",
      label: "角色名称",
      type: "input",
      rules: [{ required: true, message: "请输入角色名称" }],
      props: { placeholder: "请输入角色名称" },
    },
    {
      name: "code",
      label: "角色编码",
      type: "input",
      rules: [
        { required: true, message: "请输入角色编码" },
        {
          validator: (_: any, value: string) => {
            if (!value) {
              return Promise.resolve();
            }
            // 转换为大写进行验证
            const upperValue = value.toUpperCase();
            const pattern = /^[A-Z_-]+$/;
            if (!pattern.test(upperValue)) {
              return Promise.reject(new Error("角色编码只能包含大写字母、连字符(-)和下划线(_)"));
            }
            return Promise.resolve();
          },
          trigger: "blur",
        },
      ],
      props: {
        placeholder: "请输入角色编码 (如: ADMIN、EDITOR、USER_MANAGER、STUN-ADMIN)",
        style: { textTransform: "uppercase" }, // 自动转换为大写
      },
    },
    {
      name: "description",
      label: "描述",
      type: "textarea",
      props: {
        placeholder: "请输入角色描述",
        rows: 4,
        maxLength: 500,
      },
    },
    {
      name: "status",
      label: "状态",
      type: "select",
      props: { placeholder: "请选择状态" },
      options: [
        { value: "active", label: "启用" },
        { value: "inactive", label: "禁用" },
      ],
    },
  ],

  /**
   * 编辑角色表单配置
   */
  editFormConfig: (): FormItemConfig[] => [
    {
      name: "name",
      label: "角色名称",
      type: "input",
      rules: [{ required: true, message: "请输入角色名称" }],
      props: { placeholder: "请输入角色名称" },
    },
    {
      name: "code",
      label: "角色编码",
      type: "input",
      rules: [
        { required: true, message: "请输入角色编码" },
        {
          validator: (_: any, value: string) => {
            if (!value) {
              return Promise.resolve();
            }
            // 转换为大写进行验证
            const upperValue = value.toUpperCase();
            const pattern = /^[A-Z_-]+$/;
            if (!pattern.test(upperValue)) {
              return Promise.reject(new Error("角色编码只能包含大写字母、连字符(-)和下划线(_)"));
            }
            return Promise.resolve();
          },
          trigger: "blur",
        },
      ],
      props: {
        placeholder: "请输入角色编码 (如: ADMIN、EDITOR、USER_MANAGER、STUN-ADMIN)",
        disabled: true, // 编辑时不允许修改编码
        style: { textTransform: "uppercase" }, // 自动转换为大写
      },
    },
    {
      name: "description",
      label: "描述",
      type: "textarea",
      props: {
        placeholder: "请输入角色描述",
        rows: 4,
        maxLength: 500,
      },
    },
    {
      name: "status",
      label: "状态",
      type: "select",
      props: { placeholder: "请选择状态" },
      options: [
        { value: "active", label: "启用" },
        { value: "inactive", label: "禁用" },
      ],
    },
  ],

  /**
   * 角色Modal通用配置
   */
  modalProps: {
    width: 600,
    destroyOnClose: true,
    layout: "horizontal" as const,
    okText: "确定",
    cancelText: "取消",
  },
};


